import { Switch } from "@/components/ui/switch";
import { Field, PageHead, Panel, SaveBar, useSettings } from "@/admin/ui";

export default function Settings() {
  const { s, set, save, saving } = useSettings();
  if (!s) return <div className="h-64 rounded-[22px] bg-white animate-pulse" />;
  const T = (sec, k, label, props = {}) => <Field label={label} hint={props.hint}><input className="rh-input" value={s[sec][k] ?? ""} onChange={set(sec, k)} data-testid={`settings-${sec}-${k}`} {...props} hint={undefined} /></Field>;
  const A = (sec, k, label, rows = 4) => <Field label={label}><textarea rows={rows} className="rh-input" value={s[sec][k] ?? ""} onChange={set(sec, k)} data-testid={`settings-${sec}-${k}`} /></Field>;

  return (
    <div className="space-y-6" data-testid="admin-settings">
      <PageHead title="Settings" sub="Payment, shipping, contact and policies." />
      <Panel title="UPI payment" sub="Each order gets its own QR code with the exact amount and order ID.">
        <label className="flex items-center gap-3 font-bold mb-5"><Switch checked={!!s.payment.upi_enabled} onCheckedChange={set("payment", "upi_enabled")} data-testid="settings-upi-enabled" />Accept UPI payments</label>
        <div className="grid sm:grid-cols-2 gap-4">
          {T("payment", "upi_id", "UPI ID", { hint: "e.g. yourname@oksbi — payments go here" })}
          {T("payment", "merchant_name", "Name shown in UPI app", { hint: "Ideally the name on your UPI account" })}
          <div className="sm:col-span-2">{A("payment", "instructions", "Payment instructions shown to customers", 3)}</div>
          <Field label="QR colour">
            <select className="rh-input" value={s.payment.qr_color} onChange={set("payment", "qr_color")} data-testid="settings-payment-qr_color">
              <option value="#30202D">Deep plum</option><option value="#000000">Black</option><option value="#77384E">Royal berry</option>
            </select>
          </Field>
        </div>
      </Panel>
      <Panel title="Shipping">
        <div className="grid sm:grid-cols-3 gap-4">
          {T("shipping", "charge", "Shipping charge (₹)", { type: "number", min: 0 })}
          {T("shipping", "free_threshold", "Free shipping above (₹)", { type: "number", min: 0 })}
          {T("shipping", "dispatch_text", "Dispatch time text")}
        </div>
      </Panel>
      <Panel title="Contact">
        <div className="grid sm:grid-cols-2 gap-4">
          {T("contact", "email", "Email")}
          {T("contact", "phone", "Phone")}
          {T("contact", "whatsapp", "WhatsApp number")}
          {T("contact", "address", "Address")}
        </div>
      </Panel>
      <Panel title="Social links">
        <div className="grid sm:grid-cols-2 gap-4">
          {T("social", "instagram", "Instagram link")}
          {T("social", "facebook", "Facebook link")}
          {T("social", "youtube", "YouTube link")}
          {T("social", "pinterest", "Pinterest link")}
        </div>
      </Panel>
      <Panel title="Policies">
        <div className="grid gap-4">
          {A("policies", "shipping", "Shipping policy")}
          {A("policies", "returns", "Returns policy")}
          {A("policies", "care", "Jewellery care")}
          {A("policies", "privacy", "Privacy policy")}
          {A("policies", "terms", "Terms")}
        </div>
      </Panel>
      <Panel title="Search engine (SEO)">
        <div className="grid gap-4">{T("seo", "title", "Site title")}{A("seo", "description", "Site description", 2)}</div>
      </Panel>
      <SaveBar save={save} saving={saving} />
    </div>
  );
}
